import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const STORAGE_KEY = 'gl_token';

export function getToken() {
  return localStorage.getItem(STORAGE_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(STORAGE_KEY, token);
  else localStorage.removeItem(STORAGE_KEY);
}

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith('/login') && !path.startsWith('/r/')) {
        setToken(null);
        window.location.assign('/login');
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err.message || 'Something went wrong.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  if (d?.msg) return d.msg;
  return String(d);
}

/** Build a media download URL that works in <img src> via ?auth= query. */
export function mediaUrl(mediaId) {
  const token = getToken();
  return `${API_BASE}/media/${mediaId}/download?auth=${encodeURIComponent(token || '')}`;
}

export function publicMediaUrl(mediaId, publicToken) {
  return `${API_BASE}/public/media/${mediaId}?token=${encodeURIComponent(publicToken)}`;
}

export function reportPdfUrl(reportId) {
  const token = getToken();
  return `${API_BASE}/reports/${reportId}/pdf?auth=${encodeURIComponent(token || '')}`;
}

export function publicReportPdfUrl(publicToken) {
  return `${API_BASE}/public/reports/${publicToken}/pdf`;
}
